var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import styled, { th } from '@xstyled/styled-components';
var fontSizeMap = {
    small: '14px',
    medium: '16px',
    big: '20px',
};
var paddingMap = {
    small: '2px 8px',
    medium: '7px 10px',
    big: '12px 12px',
};
var borderRadiusMap = {
    small: '6px',
    medium: '20px',
    big: '20px',
};
var getTextColor = function (isNotSelected, textColor) {
    if (textColor) {
        return th.color(textColor);
    }
    return isNotSelected ? th.color('blue2') : 'white';
};
var getBgColor = function (color) {
    return color ? th.color(color) : 'rgba(157, 163, 169, 0.2)';
};
var Tag = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  background-color: ", ";\n  margin-right: 10px;\n  color: ", ";\n  width: fit-content;\n  transition: all 300ms cubic-bezier(0.4, 0, 0.2, 1) 0ms, box-shadow 300ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;\n  text-align: center;\n  white-space: nowrap;\n  display: flex;\n  align-items: center;\n  font-size: 14px;\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n\n  & span {\n    &:first-letter {\n      text-transform: uppercase;\n    }\n  }\n}\n"], ["\n  background-color: ", ";\n  margin-right: 10px;\n  color: ", ";\n  width: fit-content;\n  transition: all 300ms cubic-bezier(0.4, 0, 0.2, 1) 0ms, box-shadow 300ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;\n  text-align: center;\n  white-space: nowrap;\n  display: flex;\n  align-items: center;\n  font-size: 14px;\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n\n  & span {\n    &:first-letter {\n      text-transform: uppercase;\n    }\n  }\n}\n"])), function (_a) {
    var color = _a.color;
    return getBgColor(color);
}, function (_a) {
    var isNotSelected = _a.isNotSelected, textColor = _a.textColor;
    return getTextColor(isNotSelected, textColor);
}, function (_a) {
    var size = _a.size;
    return "border-radius: ".concat(borderRadiusMap[size || 'medium']);
}, function (_a) {
    var size = _a.size;
    return "font-size: ".concat(fontSizeMap[size || 'medium']);
}, function (_a) {
    var size = _a.size;
    return "padding: ".concat(paddingMap[size || 'medium']);
}, function (_a) {
    var border = _a.border;
    return border && 'border: 1px solid rgba(0, 0, 0, 0.65);';
}, function (_a) {
    var opacity = _a.opacity;
    return opacity && 'opacity: 0.7';
}, function (_a) {
    var pointer = _a.pointer;
    return pointer && 'cursor: pointer;';
}, function (_a) {
    var hover = _a.hover;
    return hover && '&: hover { opacity: 0.7}';
});
export default Tag;
var templateObject_1;
